import React from 'react';

const NotFound = () => {
    return (
        <div className="container mb-5 " style={{ height: "500px" }}>

            <h1 className="fs-1 mt-5">NOT FOUND</h1>
            <h2 className="fs-2">We do Not found this Page . Plz Check out the Right URL</h2>

        </div>
    );
};

export default NotFound;